import React, { useMemo, useState } from 'react';
import { Search } from 'lucide-react';
import { AdminRecordRow } from './AdminRecordRow';

export const AdminRecordList = ({ tab, records, loading }) => {
  const [query, setQuery] = useState('');

  const filtered = useMemo(() => {
    const q = query.trim().toLowerCase();
    return q ? records.filter((r) => JSON.stringify(r).toLowerCase().includes(q)) : records;
  }, [records, query]);

  return (
    <section data-testid={`admin-list-${tab.key}`}>
      <div className="relative mb-6">
        <Search className="pointer-events-none absolute left-4 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-500" aria-hidden="true" />
        <input type="search" value={query} onChange={(e) => setQuery(e.target.value)} placeholder={`Search ${tab.label.toLowerCase()}…`} className="w-full border border-gray-300 bg-white py-3 pl-11 pr-4 text-base focus:border-gray-900 focus:outline-none" data-testid="admin-search-input" />
      </div>
      {loading && !records.length && <p className="text-sm text-gray-500" data-testid="admin-loading">Loading…</p>}
      {!loading && !filtered.length && <p className="border border-gray-200 bg-white p-8 text-sm text-gray-600" data-testid="admin-empty-state">No {tab.label.toLowerCase()} found.</p>}
      <ul className="divide-y divide-gray-200 border border-gray-200 bg-white">
        {filtered.map((record) => <AdminRecordRow key={record.id} tab={tab} record={record} />)}
      </ul>
    </section>
  );
};
